//import $ from 'jquery';
//window.jQuery = $;

import Main from './src/main';

$(document).ready( ()=>{

	const app = new Main({
		is_ajax: true,
		is_locomotive: false,
		is_locomotive_touch: false,
		$scroll_el: '#smooth-scroll',
		debug: false,
		slide_transition: false,
		time_fade_in 	: 0.2,
		time_fade_out 	: 0.17,
		project_name: 'Madison Square Park',

		skip_intro: false,

		preventURLS: [
			'/support/fundraising-events/a-taste-of-asia-in-nyc/',
            '/support/more-ways-to-give/employer-matching-donations/',
            '/support/donate-main/',
            '/support/donate/',
            '/support/home/',
		],

	});

	app.init()
	
}); 



